export const STAGGERED = 'Staggered'
